export default __webpack_public_path__ + "static/media/Percent.fce4d805.svg";